 // eslint-disable-next-line no-unused-vars
import Modal from 'bootstrap/js/dist/modal';
let activeModal;

function modalEvent(memberContainers) {
   
    const modal = document.getElementById('member-modal');

    memberContainers.forEach((container) => {
        const member = container.querySelectorAll('.member');

        member.forEach((memb) => {
            memb.addEventListener('click', showModal);
        })
    });

    modal.addEventListener('hidden.bs.modal', () => {
       if(activeModal) activeModal.classList.remove('is-active')
    });

}

function showModal() {
    const modal = document.getElementById('member-modal');
    const modalContent = modal.querySelector('.modal-body');
    modalContent.innerHTML = '';
    
    activeModal = this;
    activeModal.classList.add('is-active');

    
    const image = this.querySelector('.image-container');
    if(image){
        const tempImage = image.cloneNode(true)
        modalContent.appendChild(tempImage);
    }

    const memberInfo = this.querySelector('.member-info');
    if(memberInfo) {
        const tempMemberInfo  = memberInfo.cloneNode(true);
        modalContent.appendChild(tempMemberInfo);
    }

    const name = this.querySelector('.name');
    if(name) {
        const userInfo = modalContent.querySelector('.member-info');
        const firstChild = userInfo.querySelector('.title');
        const nameModal = document.createElement('h3');

        nameModal.textContent =  name.innerHTML;

        userInfo.insertBefore(nameModal, firstChild)
    }
}


document.addEventListener( 'DOMContentLoaded', () => {
    const memberContainers = document.querySelectorAll('.block-members__container');

    if(memberContainers.length) modalEvent(memberContainers);
} );
